// src/oura/components/docs/write/shareChecks.ts
//
// Which pre-share checks this frontend knows by name, and which of them it can
// put right in one click. Its own module so ShareView stays a component file.

import type { ShareCheckCode, ShareCheckItem } from "@service/aeo/clientDocsWrite";

/**
 * The 3 checks this screen knows, in order, with what each says when it passes.
 *
 * NOT the whole list. The server adds checks without a release here, so
 * anything it sends that is not one of these is rendered after them rather
 * than dropped: an unknown item already holds the share (`ok` is false), and a
 * Share refused "until the checks in red are fixed" with nothing in red is a
 * dead end (#4051, ourteam-backend#5519).
 */
export const CHECKS: Array<{ code: ShareCheckCode; ok: string }> = [
    { code: "link_sharing", ok: "Link sharing is off." },
    // Named people only: anyone-with-the-link editing is the link sharing check's.
    { code: "edit_access", ok: "No named person outside ourteam can edit." },
    { code: "internal_notes", ok: "No internal notes of ours in the doc." },
];

export const KNOWN_CHECKS = new Set<string>(CHECKS.map((c) => c.code));

/**
 * The codes `fixShareCheck` can put right in one click. Anything else is fixed
 * in the doc, so its row offers the doc rather than a button that does nothing.
 */
export const FIXABLE = new Set<string>(["link_sharing", "edit_access"]);

/** The items for checks this screen has no row of its own for. */
export function unknownChecks(items: readonly ShareCheckItem[]): ShareCheckItem[] {
    return items.filter((i) => !KNOWN_CHECKS.has(i.code));
}
